import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Box, Link, Button, Drawer, Typography, Avatar, Stack } from '@mui/material';

// hooks
import useResponsive from '../../../hooks/useResponsive';
// components

import NavSection from '../../../components/nav-section';
//
import {useNavConfig, useNavLogin} from './config';
import BasicMenu from './submenuslide'; 
// ----------------------------------------------------------------------


// ----------------------------------------------------------------------

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function Nav({ openNav, onCloseNav }) {

  const navConfig = useNavConfig();
  const navConfigLogin = useNavLogin();

  const { pathname } = useLocation();
 
   const [userLogin, setUserLoginInfo] = useState("");
  const isDesktop = useResponsive('up', 'lg');

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }

    if (sessionStorage.getItem('login_info') !== null) {
      setUserLoginInfo(sessionStorage.getItem('login_info'));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContentLogin = (
      <NavSection data={navConfigLogin} style={{ display : 'flex',}}/>
  );

  const renderContent = (
    <NavSection data={navConfig} style={{ display : 'flex',}}/>

);


  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        border:'none',
        position:'unset',
        display:'flex',
        flexGrow:1,
        justifyContent:'center',
        '& .MuiPaper-root':{
            overflow:'hidden'
        }
      }}
    >
      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              display:'flex',
              position:'unset',
              border:'none',
              background:'none',
              '& a':{
                margin:'0 30px'
              }
            },
          }}
        >
          {renderContent}
          
          {/* {userLogin ?  (renderContentLogin) :(renderContent)  } */}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{

          }}
        >
          {renderContent}
        </Drawer>
      )}
      
    </Box>
  );
}
